module.exports = __webpack_public_path__ + "static/img/coins.c6970d2a.webp";